import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";


export default (props) => {//shows additional surcharges or charges.
    let IV1_PageDetails = useContext(RecordsManagementContext).IV1_PageDetails
    let price = props.price
    return (
        <>
            <tr >
                <td className="table_text">{props.name}</td>
                <td>
                    <div className="col-auto">
                        <div className="input-group mb-2" >
                            <div className="input-group-prepend" >
                                {price.toString().includes('%') ? '' : <div className="input-group-text">{props.currency}</div>}
                            </div>
                            <input type="text" className="form-control input_design_2"
                                   id="inlineFormInputGroup" placeholder={price} disabled/>
                        </div>
                    </div>
                </td>
            </tr>
        </>
    )
}